export const currentTimestamp = () => new Date().getTime()

// Must be in lowercase
export const POOL_HIDE: string[] = [];
export const MATIC_ADDRESS: string = ''; // Lowercase